import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import store from "./store";
import vuetify from "./plugins/vuetify";

import "@mdi/font/css/materialdesignicons.css";
Vue.use(vuetify, { iconfont: "mdi" });

import KoioteNavigationPlugin from "./plugins/navigation/KoioteNavigationPlugin";
Vue.use(KoioteNavigationPlugin);

import KoioteOmronConnectionPlugin from "./plugins/omron_connection/KoioteOmronConnectionPlugin";
Vue.use(KoioteOmronConnectionPlugin);

import KoioteSnap7ConnectionPlugin from "./plugins/snap7_connection/KoioteSnap7ConnectionPlugin";
Vue.use(KoioteSnap7ConnectionPlugin);

import KoioteImageSwitchCanvasPlugin from "./plugins/image_switch_canvas/KoioteImageSwitchCanvasPlugin";
Vue.use(KoioteImageSwitchCanvasPlugin);

import KoioteValueLabelPlugin from "./plugins/value_label/KoioteValueLabelPlugin";
Vue.use(KoioteValueLabelPlugin);

import KoioteValueLabelWritePlugin from "./plugins/value_label_write/KoioteValueLabelWritePlugin";
Vue.use(KoioteValueLabelWritePlugin);

import KoioteButtonFeedbackPlugin from "./plugins/button_feedback/KoioteButtonFeedbackPlugin";
Vue.use(KoioteButtonFeedbackPlugin);

import KoioteTankCanvasPlugin from "./plugins/tank_canvas/KoioteTankCanvasPlugin";
Vue.use(KoioteTankCanvasPlugin);

import KoioteSiloCanvasPlugin from "./plugins/silo_canvas/KoioteSiloCanvasPlugin";
Vue.use(KoioteSiloCanvasPlugin);

import GraficoEstadosPlugin from "./plugins/grafico_estados/GraficoEstadosPlugin";
Vue.use(GraficoEstadosPlugin);

import FiltroEntreFechas from "./plugins/filtro_fecha_hora_inicial/FiltroEntreFechas";
Vue.use(FiltroEntreFechas);

import GraficoEstadosV1 from "./plugins/grafico_estados_v1/GraficoEstadosV1Plugin";
Vue.use(GraficoEstadosV1);

import GraficoEstadosPorcentajePlugin from "./plugins/grafico_estados_porcentaje/GraficoEstadosPorcentajePlugin";
Vue.use(GraficoEstadosPorcentajePlugin);

import DescargaDatosPlugin from "./plugins/data_download/DescargaDatosPlugin";
Vue.use(DescargaDatosPlugin);

import BotonDirectoPlugin from "./plugins/en_directo/BotonDirectoPlugin";
Vue.use(BotonDirectoPlugin);

import KoioteLabelPlugin from "./plugins/canvas_label/KoioteLabelPlugin";
Vue.use(KoioteLabelPlugin);

import KoioteTablaPlugin from "./plugins/tabla/KoioteTablaPlugin";
Vue.use(KoioteTablaPlugin);

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
